var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListItemAccount',_vm._b({key:_vm.user.login},'ListItemAccount',{
    type: _vm.user.type,
    avatar: _vm.user.avatar,
    name: _vm.$filters.displayName(_vm.user),
    accountId: _vm.user.login,
    approved: _vm.user.approved,
    role: _vm.roleString,
    vanityId: _vm.user.vanityId || _vm.user.vanity_id,
  },false),[(_vm.actions.length)?_c('template',{slot:"action"},[(_vm.actions.length > 1)?_c('ThreeDots',{attrs:{"items":_vm.actions}}):_c('Icon',{staticClass:"cursor-pointer",attrs:{"name":"chat"},on:{"click":function($event){$event.preventDefault();return _vm.actions[0].action($event)}}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }